<iframe *ngIf="wopiSettingUpUrl"
  style="width:100%;height:100%;position:absolute;left:0;top:0;bottom:0;right:0;border:none;"
  [src]="wopiSettingUpUrl | trustUrl"
  title="Office Online"></iframe>
